/* tslint:disable */
/* eslint-disable */
/**
 * Universal Process API
 * Universal Process App API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BaseErrorResponseDto } from '../models';
// @ts-ignore
import type { CreateProcessRequestDto } from '../models';
// @ts-ignore
import type { CustomerErrorResponseDto } from '../models';
// @ts-ignore
import type { ProcessCalendarEntryQueryDto } from '../models';
// @ts-ignore
import type { ProcessCreationDefaultDataDto } from '../models';
// @ts-ignore
import type { ProcessCreationResponseDto } from '../models';
// @ts-ignore
import type { ProcessDto } from '../models';
// @ts-ignore
import type { ProcessPageableResponseDto } from '../models';
// @ts-ignore
import type { ProcessSearchRequestDto } from '../models';
// @ts-ignore
import type { ProcessShortDetailsDto } from '../models';
// @ts-ignore
import type { ProcessTodoInfoDto } from '../models';
// @ts-ignore
import type { UpdateProcessRequestDto } from '../models';
// @ts-ignore
import type { UpdateProcessStatusRequestDto } from '../models';
/**
 * RestProcessesApi - axios parameter creator
 */
export const RestProcessesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateProcessRequestDto} createProcessRequestDto Start process request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProcess: async (createProcessRequestDto: CreateProcessRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createProcessRequestDto' is not null or undefined
            assertParamExists('createProcess', 'createProcessRequestDto', createProcessRequestDto)
            const localVarPath = `/api/processes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createProcessRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcess: async (processId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getProcess', 'processId', processId)
            const localVarPath = `/api/processes/{processId}`
                .replace('{processId}', encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {string} [emailThreadId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessCreationDefaultData: async (email: string, emailThreadId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('getProcessCreationDefaultData', 'email', email)
            const localVarPath = `/api/processes/default-data`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (emailThreadId !== undefined) {
                localVarQueryParameter['emailThreadId'] = emailThreadId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessTodoInfo: async (processId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getProcessTodoInfo', 'processId', processId)
            const localVarPath = `/api/processes/{processId}/todo`
                .replace('{processId}', encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessesShortList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/processes/short`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {ProcessSearchRequestDto} processSearchRequestDto Processes search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProcesses: async (page: number, pageSize: number, processSearchRequestDto: ProcessSearchRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('searchProcesses', 'page', page)
            // verify required parameter 'pageSize' is not null or undefined
            assertParamExists('searchProcesses', 'pageSize', pageSize)
            // verify required parameter 'processSearchRequestDto' is not null or undefined
            assertParamExists('searchProcesses', 'processSearchRequestDto', processSearchRequestDto)
            const localVarPath = `/api/processes/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(processSearchRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} processId 
         * @param {UpdateProcessRequestDto} updateProcessRequestDto Update process request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcess: async (processId: string, updateProcessRequestDto: UpdateProcessRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('updateProcess', 'processId', processId)
            // verify required parameter 'updateProcessRequestDto' is not null or undefined
            assertParamExists('updateProcess', 'updateProcessRequestDto', updateProcessRequestDto)
            const localVarPath = `/api/processes/{processId}`
                .replace('{processId}', encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProcessRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Replace or clear the calendar entry query of the process
         * @param {string} processId 
         * @param {ProcessCalendarEntryQueryDto} processCalendarEntryQueryDto Replaces the calendar entry query of the process; empty fields clear it
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessCalendarEntryQuery: async (processId: string, processCalendarEntryQueryDto: ProcessCalendarEntryQueryDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('updateProcessCalendarEntryQuery', 'processId', processId)
            // verify required parameter 'processCalendarEntryQueryDto' is not null or undefined
            assertParamExists('updateProcessCalendarEntryQuery', 'processCalendarEntryQueryDto', processCalendarEntryQueryDto)
            const localVarPath = `/api/processes/{processId}/calendar-entry-query`
                .replace('{processId}', encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(processCalendarEntryQueryDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update process\'s status
         * @param {string} processId 
         * @param {UpdateProcessStatusRequestDto} updateProcessStatusRequestDto Processes task update request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessStatus: async (processId: string, updateProcessStatusRequestDto: UpdateProcessStatusRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('updateProcessStatus', 'processId', processId)
            // verify required parameter 'updateProcessStatusRequestDto' is not null or undefined
            assertParamExists('updateProcessStatus', 'updateProcessStatusRequestDto', updateProcessStatusRequestDto)
            const localVarPath = `/api/processes/{processId}/status`
                .replace('{processId}', encodeURIComponent(String(processId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProcessStatusRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestProcessesApi - functional programming interface
 */
export const RestProcessesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestProcessesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateProcessRequestDto} createProcessRequestDto Start process request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createProcess(createProcessRequestDto: CreateProcessRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessCreationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createProcess(createProcessRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessesApi.createProcess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProcess(processId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProcess(processId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessesApi.getProcess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} email 
         * @param {string} [emailThreadId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProcessCreationDefaultData(email: string, emailThreadId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessCreationDefaultDataDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProcessCreationDefaultData(email, emailThreadId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessesApi.getProcessCreationDefaultData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProcessTodoInfo(processId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessTodoInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProcessTodoInfo(processId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessesApi.getProcessTodoInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProcessesShortList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProcessShortDetailsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProcessesShortList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessesApi.getProcessesShortList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {ProcessSearchRequestDto} processSearchRequestDto Processes search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchProcesses(page: number, pageSize: number, processSearchRequestDto: ProcessSearchRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProcessPageableResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchProcesses(page, pageSize, processSearchRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessesApi.searchProcesses']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} processId 
         * @param {UpdateProcessRequestDto} updateProcessRequestDto Update process request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProcess(processId: string, updateProcessRequestDto: UpdateProcessRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProcess(processId, updateProcessRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessesApi.updateProcess']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Replace or clear the calendar entry query of the process
         * @param {string} processId 
         * @param {ProcessCalendarEntryQueryDto} processCalendarEntryQueryDto Replaces the calendar entry query of the process; empty fields clear it
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProcessCalendarEntryQuery(processId: string, processCalendarEntryQueryDto: ProcessCalendarEntryQueryDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProcessCalendarEntryQuery(processId, processCalendarEntryQueryDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessesApi.updateProcessCalendarEntryQuery']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update process\'s status
         * @param {string} processId 
         * @param {UpdateProcessStatusRequestDto} updateProcessStatusRequestDto Processes task update request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProcessStatus(processId: string, updateProcessStatusRequestDto: UpdateProcessStatusRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProcessStatus(processId, updateProcessStatusRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestProcessesApi.updateProcessStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestProcessesApi - factory interface
 */
export const RestProcessesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestProcessesApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateProcessRequestDto} createProcessRequestDto Start process request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createProcess(createProcessRequestDto: CreateProcessRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ProcessCreationResponseDto> {
            return localVarFp.createProcess(createProcessRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcess(processId: string, options?: RawAxiosRequestConfig): AxiosPromise<ProcessDto> {
            return localVarFp.getProcess(processId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} email 
         * @param {string} [emailThreadId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessCreationDefaultData(email: string, emailThreadId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ProcessCreationDefaultDataDto> {
            return localVarFp.getProcessCreationDefaultData(email, emailThreadId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} processId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessTodoInfo(processId: string, options?: RawAxiosRequestConfig): AxiosPromise<ProcessTodoInfoDto> {
            return localVarFp.getProcessTodoInfo(processId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessesShortList(options?: RawAxiosRequestConfig): AxiosPromise<Array<ProcessShortDetailsDto>> {
            return localVarFp.getProcessesShortList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} page 
         * @param {number} pageSize 
         * @param {ProcessSearchRequestDto} processSearchRequestDto Processes search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchProcesses(page: number, pageSize: number, processSearchRequestDto: ProcessSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ProcessPageableResponseDto> {
            return localVarFp.searchProcesses(page, pageSize, processSearchRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} processId 
         * @param {UpdateProcessRequestDto} updateProcessRequestDto Update process request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcess(processId: string, updateProcessRequestDto: UpdateProcessRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateProcess(processId, updateProcessRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Replace or clear the calendar entry query of the process
         * @param {string} processId 
         * @param {ProcessCalendarEntryQueryDto} processCalendarEntryQueryDto Replaces the calendar entry query of the process; empty fields clear it
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessCalendarEntryQuery(processId: string, processCalendarEntryQueryDto: ProcessCalendarEntryQueryDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateProcessCalendarEntryQuery(processId, processCalendarEntryQueryDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update process\'s status
         * @param {string} processId 
         * @param {UpdateProcessStatusRequestDto} updateProcessStatusRequestDto Processes task update request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProcessStatus(processId: string, updateProcessStatusRequestDto: UpdateProcessStatusRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateProcessStatus(processId, updateProcessStatusRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestProcessesApi - interface
 */
export interface RestProcessesApiInterface {
    /**
     * 
     * @param {CreateProcessRequestDto} createProcessRequestDto Start process request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createProcess(createProcessRequestDto: CreateProcessRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ProcessCreationResponseDto>;

    /**
     * 
     * @param {string} processId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcess(processId: string, options?: RawAxiosRequestConfig): AxiosPromise<ProcessDto>;

    /**
     * 
     * @param {string} email 
     * @param {string} [emailThreadId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcessCreationDefaultData(email: string, emailThreadId?: string, options?: RawAxiosRequestConfig): AxiosPromise<ProcessCreationDefaultDataDto>;

    /**
     * 
     * @param {string} processId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcessTodoInfo(processId: string, options?: RawAxiosRequestConfig): AxiosPromise<ProcessTodoInfoDto>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProcessesShortList(options?: RawAxiosRequestConfig): AxiosPromise<Array<ProcessShortDetailsDto>>;

    /**
     * 
     * @param {number} page 
     * @param {number} pageSize 
     * @param {ProcessSearchRequestDto} processSearchRequestDto Processes search request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchProcesses(page: number, pageSize: number, processSearchRequestDto: ProcessSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ProcessPageableResponseDto>;

    /**
     * 
     * @param {string} processId 
     * @param {UpdateProcessRequestDto} updateProcessRequestDto Update process request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProcess(processId: string, updateProcessRequestDto: UpdateProcessRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Replace or clear the calendar entry query of the process
     * @param {string} processId 
     * @param {ProcessCalendarEntryQueryDto} processCalendarEntryQueryDto Replaces the calendar entry query of the process; empty fields clear it
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProcessCalendarEntryQuery(processId: string, processCalendarEntryQueryDto: ProcessCalendarEntryQueryDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Update process\'s status
     * @param {string} processId 
     * @param {UpdateProcessStatusRequestDto} updateProcessStatusRequestDto Processes task update request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProcessStatus(processId: string, updateProcessStatusRequestDto: UpdateProcessStatusRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * RestProcessesApi - object-oriented interface
 */
export class RestProcessesApi extends BaseAPI implements RestProcessesApiInterface {
    /**
     * 
     * @param {CreateProcessRequestDto} createProcessRequestDto Start process request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createProcess(createProcessRequestDto: CreateProcessRequestDto, options?: RawAxiosRequestConfig) {
        return RestProcessesApiFp(this.configuration).createProcess(createProcessRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} processId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProcess(processId: string, options?: RawAxiosRequestConfig) {
        return RestProcessesApiFp(this.configuration).getProcess(processId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} email 
     * @param {string} [emailThreadId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProcessCreationDefaultData(email: string, emailThreadId?: string, options?: RawAxiosRequestConfig) {
        return RestProcessesApiFp(this.configuration).getProcessCreationDefaultData(email, emailThreadId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} processId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProcessTodoInfo(processId: string, options?: RawAxiosRequestConfig) {
        return RestProcessesApiFp(this.configuration).getProcessTodoInfo(processId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getProcessesShortList(options?: RawAxiosRequestConfig) {
        return RestProcessesApiFp(this.configuration).getProcessesShortList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} page 
     * @param {number} pageSize 
     * @param {ProcessSearchRequestDto} processSearchRequestDto Processes search request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchProcesses(page: number, pageSize: number, processSearchRequestDto: ProcessSearchRequestDto, options?: RawAxiosRequestConfig) {
        return RestProcessesApiFp(this.configuration).searchProcesses(page, pageSize, processSearchRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} processId 
     * @param {UpdateProcessRequestDto} updateProcessRequestDto Update process request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateProcess(processId: string, updateProcessRequestDto: UpdateProcessRequestDto, options?: RawAxiosRequestConfig) {
        return RestProcessesApiFp(this.configuration).updateProcess(processId, updateProcessRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Replace or clear the calendar entry query of the process
     * @param {string} processId 
     * @param {ProcessCalendarEntryQueryDto} processCalendarEntryQueryDto Replaces the calendar entry query of the process; empty fields clear it
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateProcessCalendarEntryQuery(processId: string, processCalendarEntryQueryDto: ProcessCalendarEntryQueryDto, options?: RawAxiosRequestConfig) {
        return RestProcessesApiFp(this.configuration).updateProcessCalendarEntryQuery(processId, processCalendarEntryQueryDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update process\'s status
     * @param {string} processId 
     * @param {UpdateProcessStatusRequestDto} updateProcessStatusRequestDto Processes task update request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateProcessStatus(processId: string, updateProcessStatusRequestDto: UpdateProcessStatusRequestDto, options?: RawAxiosRequestConfig) {
        return RestProcessesApiFp(this.configuration).updateProcessStatus(processId, updateProcessStatusRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

